import { SystemAction, SystemState } from "./types";


const initialState: SystemState = {
    user: null,
};

export const systemReducer = (state = initialState, action: SystemAction): SystemState => (
    action.type === 'LOG_IN' ? ({
        ...state,
        user: action.user,
    }) :
    action.type === 'LOG_OUT' ? ({
        ...state,
        user: null,
    }) : 
    state
);
